import styled from 'styled-components';

import { Typography } from '../typography';

const Wrapper = styled.div`
	display: flex;
	padding: 0 32px;
	min-height: 250px;
`;

const Count = styled(Typography)`
	font-size: 52px;
	line-height: 40px;
`;

const exportedObject = { Wrapper, Count };

export default exportedObject;
